import type {AxiosPromise} from 'axios'
import axios from '@/plugin/axios'
import api from '@/api'
import config from '@/config'

export const contentService = {
  fetchRegionTranslations,
  fetchBackupTranslations,
  fetchSafetyDocs
}

function fetchRegionTranslations(_region: string): AxiosPromise {
  return axios.get(api.endpoints.CONTENT_API.REGION_TRANSLATIONS.replace('{region}', _region))
}

function fetchBackupTranslations(_region: string): AxiosPromise {
  return axios.get(config.publicPath + '/translations/{region}.json'.replace('{region}', _region))
}

function fetchSafetyDocs(_region: string, lang: string = 'all'): AxiosPromise {
  return axios.get(
    api.endpoints.CONTENT_API.SAFETY_DOCS.replace('{region}', _region.toLowerCase()),
    {params: {lang}}
  )
}
